import { Image } from "@chakra-ui/react";
import { FC } from "react";

const SearchIcon: FC<{
    mt?: string;
    mb?: string;

}> = ({ mb, mt }) => {
    return <Image
        src="/images/search.svg"
        mt={mt}
        mb={mb}
        w="24px"
        h="24px"
        _hover={{ cursor: "pointer" }}
        color="#8C8C8C"
    />;
};
export default SearchIcon;
